import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import menubar from "../images/menubar.svg";
import Searchicon from "../components/searchicon";
import Profileimage from "../assets/icons/profile.jpg";
import Maximizeicon from "../assets/icons/maximize_icon";
import Bellicon from "../assets/icons/Bellicon";
import Messageicon from "../assets/icons/Messageicon";
import Customericon from "../assets/icons/customer_icon";
import EnvelopeIcon from "../assets/icons/envelop_icon";
import LockIcon from "../assets/icons/lock_icon";
import Settingicon from "../assets/icons/setting_icon";
import LogoutIcon from '../assets/icons/logout_icon';
import FlagTh from "../images/flag_th";
import FlagEn from "../images/flag_en";
import Logo from "../images/bentex-logo.png";
import ThreeDots from "../images/ThreeDots"


const Header = ({ toggleSidebar }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navigate = useNavigate();

  const handleProfileClick = () => {
    setIsDropdownVisible((prevState) => !prevState);
  };

  const [isToggled, setIsToggled] = useState(false);
  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
  };


  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
    setIsDropdownVisible(false); 
  };

  return (
    <div className="header main-header">
      <div className="logo for_mobile">
        <img src={Logo} alt="" />
      </div>
      <div className="sidebar-opener" onClick={toggleSidebar}>
        <img src={menubar} />
      </div>

      {/* <div className="header-search">
        <span className="search-icon">
          <Searchicon />
        </span>
        <input type="text" placeholder="Search.." className="search-bar" />
      </div> */}
      <div className="header-actions">
        <ul>
          <li className="actions-icon">
            <Maximizeicon />
          </li>
          <li className="actions-icon has_dropdown">
            <a href="" className="has_dropdown">EN</a>
            <div className="lang_drop_down">
              <ul class="language-dropdown">
                <li>
                  <a href="javascript:void(0)" data-lng="en">
                    <FlagEn /> English
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0)" data-lng="th">
                    <FlagTh /> Thai
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li className="actions-icon with_icons_outer">
            <span className="nottifications_bell"><Bellicon />
              <span className="dot"></span>
            </span>
            <span className="messages"><Messageicon />
              <span className="dot"></span>
            </span>
          </li>
          <li className="profile-container onhover_dropdown" onClick={handleProfileClick}>
            <div class="dotted-animation">
              <span class="animate-circle"></span>
              <span class="main-circle"></span>
            </div>
            <img src={Profileimage} alt="Profile" className="profile_image" />
            {isDropdownVisible && (
              <div className="dropdown-menu">
                <ul>
                  <li>
                    <a href="#">
                      <Customericon />
                      Edit Profile
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <EnvelopeIcon />
                      Inbox
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <LockIcon />
                      Lock Screen
                    </a>
                  </li>
                  <li className="border_top">
                    <a href="#">
                      <Settingicon />
                      Settings
                    </a>
                  </li>
                  <li>
                    <a className="logout-btn" onClick={handleLogout}>
                      <LogoutIcon />
                      Logout
                    </a>
                  </li>
                </ul>

              </div>
            )}
          </li>
        </ul>

      </div>
      <div className="three_dots for_mobile">
        <button className="open_lower_mobile_header" onClick={handleToggle}>
          <ThreeDots />
        </button>
      </div>
      <div className={`header_search_action_for_mobile ${isToggled ? "active" : ""}`}>
        <div className="header-search">
          <span className="search-icon">
            <Searchicon />
          </span>
          <input type="text" placeholder="Search.." className="search-bar" />
        </div>
        <div className="header-actions">
          <ul>
            <li className="actions-icon">
              <Maximizeicon />
            </li>
            <li className="actions-icon has_dropdown">
              <button className="has_dropdown">EN</button>
              <div className="lang_drop_down">
                <ul class="language-dropdown">
                  <li>
                    <a href="javascript:void(0)" data-lng="en">
                      <FlagEn /> English
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" data-lng="th">
                      <FlagTh /> Thai
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li className="actions-icon with_icons_outer">
              <span className="nottifications_bell"><Bellicon />
                <span className="dot"></span>
              </span>
              <span className="messages"><Messageicon />
                <span className="dot"></span>
              </span>
            </li>
            <li className="profile-container onhover_dropdown" onClick={handleProfileClick}>
              <div class="dotted-animation">
                <span class="animate-circle"></span>
                <span class="main-circle"></span>
              </div>
              <img src={Profileimage} alt="Profile" className="profile_image" />
              {isDropdownVisible && (
                <div className="dropdown-menu">
                  <ul>
                    <li>
                      <a href="#">
                        <Customericon />
                        Edit Profile
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <EnvelopeIcon />
                        Inbox
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <LockIcon />
                        Lock Screen
                      </a>
                    </li>
                    <li className="border_top">
                      <a href="#">
                        <Settingicon />
                        Settings
                      </a>
                    </li>
                    <li>
                      <a className="logout-btn" onClick={handleLogout}>
                        <LogoutIcon />
                        Logout
                      </a>
                    </li>
                  </ul>

                </div>
              )}
            </li>
          </ul>

        </div>
      </div>

    </div>
  );
};


export default Header;
